import { AnyAction, createSlice, Reducer, Slice } from '@reduxjs/toolkit';

import { PaginationFilters } from '../../../../../../shared/models/pagination-filters.model';
import { PaginationDefaults } from '../../../../../../shared/utils/pagination-defaults.util';
import { getStatisticsTotalCount } from '../../thunks/get-statistics-total-count.thunk';
import { getStatistics } from '../../thunks/get-statistics.thunk';
import { StatisticsStateModel } from './models/statistics-state.model';
import { StatisticsReducers } from './types/statistics-reducers.type';

const paginationInitialState: PaginationFilters = {
  totalCount: PaginationDefaults.totalCount,
  pageNumber: PaginationDefaults.pageNumber,
  size: PaginationDefaults.size,
  offset: PaginationDefaults.offset,
};

const initialState: StatisticsStateModel = {
  statistics: [],
  pagination: paginationInitialState,
};

export const statisticsSlice: Slice<
  StatisticsStateModel,
  StatisticsReducers,
  'statistics'
> = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    addPagination(state, action) {
      state.pagination.size = action.payload.size;
      state.pagination.offset = action.payload.offset;
      state.pagination.pageNumber = action.payload.pageNumber;
    },

    resetPagination(state, action) {
      state.pagination.offset = PaginationDefaults.offset;
      state.pagination.size = action.payload.size;
      state.pagination.pageNumber = PaginationDefaults.pageNumber;
    },

    setAppId(state, action) {
      state.appId = action.payload;
    },
  },

  extraReducers: builder => {
    builder.addCase(getStatistics.fulfilled, (state, action) => {
      state.statistics = action.payload;
    });
    builder.addCase(getStatisticsTotalCount.fulfilled, (state, action) => {
      state.pagination.totalCount = action.payload;
    });
  },
});

export const { addPagination, resetPagination, setAppId } =
  statisticsSlice.actions;

const statisticsSliceReducers: Reducer<StatisticsStateModel, AnyAction> =
  statisticsSlice.reducer;

export default statisticsSliceReducers;
